import { useParams } from "react-router-dom";
import { GET_AGREEMENT_BY_ID } from "utils/apiRoutes";
import { QueryKeys } from "utils/queryKey";
import { useFetchQuery } from "./useQueries";

export const useAgreement = () => {
  const { id } = useParams();

  const {
    data: getAgreement,
    refetch,
    isLoading: isAgreementLoading,
  } = useFetchQuery({
    key: [QueryKeys.AGREEMENT_LIST],
    enabled: Boolean(id),
    route: GET_AGREEMENT_BY_ID(id),
  });
  return { getAgreement, isAgreementLoading, refetch };
};
